import React from 'react';
import { 
    Radar, 
    RadarChart, 
    PolarGrid, 
    PolarAngleAxis, 
    PolarRadiusAxis, 
    ResponsiveContainer, 
    Legend, 
    Tooltip 
} from 'recharts';

/**
 * SkillRadar Component
 * Professional SIRH version (Simple Blue/Coral)
 */
const SkillRadar = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div className="eval-empty">
                <p>Aucune donnée disponible pour générer le radar.</p>
            </div>
        );
    }

    return (
        <div className="radar-container" style={{ width: '100%', height: '500px', background: '#fff', borderRadius: '12px', padding: '20px', border: '1px solid #e2e8f0' }}>
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                    <PolarGrid stroke="#e2e8f0" />
                    <PolarAngleAxis 
                        dataKey="skill" 
                        tick={{ fill: '#475569', fontSize: 11, fontWeight: 600 }}
                    />
                    <PolarRadiusAxis 
                        angle={30} 
                        domain={[0, 4]} 
                        tick={{ fill: '#94a3b8', fontSize: 10 }}
                    />
                    
                    {/* Profil Requis - Coral */}
                    <Radar
                        name="Profil Requis (Poste)"
                        dataKey="requis"
                        stroke="#ee645f"
                        fill="none"
                        strokeWidth={1.5}
                    />

                    {/* Profil Obtenu - Deep Blue */}
                    <Radar
                        name="Mon Profil (Obtenu)"
                        dataKey="obtenu"
                        stroke="#204385"
                        fill="rgba(32, 67, 133, 0.1)"
                        strokeWidth={1.5}
                    />
                    
                    <Tooltip 
                        contentStyle={{ borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}
                    />
                    <Legend verticalAlign="bottom" height={36}/>
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default SkillRadar;
